import React from 'react'

import images from '../assets'

function IconOption ({ data, type, onSelect, selected }) {
	return (
		<button
			className={`clickable hover:border-black ${selected ? 'border-green-500' : ''}`}
			onClick={() => onSelect(data.id)}
		>
			{data.devicon ? (
				<i className={`devicon-${data.id} colored`} style={{ fontSize: 120 }}></i>
			) : (
				<img src={images[type][data.id]} width="120" height="120" alt="" />
			)}
		</button>
	);
}

export default IconOption